<template>
  <div class="c-event-messaging__message">
    <div class="c-message c-message--amex c-content" data-message-type="amex">
      <img src="/themes/childtheme/assets/images/amex.png" alt="" />
      <div class="c-message__content">
        <h3 class="c-col__heading-4">American Express<sup>®</sup> Experiences</h3>
        <div v-html="output"></div>
        <button v-if="!isAmexMOS" class="c-btn c-btn--ghost c-btn--small" @click="openModal">Unlock Amex tickets</button>
        <div class="c-message__flash c-boxout c-boxout--error" :class="{ 'c-boxout--success' : messageAlertSuccessStatus }" v-if="messageFlash.length > 0" v-html="messageFlash"></div>
      </div>
    </div>
    <AmexModal />
  </div>
</template>

<script>
import AmexModal from "../AmexModal"
import {EventBus} from "../../event-bus"

export default {
  name: "Amex",
  props: ['content'],
  components: {
    AmexModal,
  },
  data() {
    return {
      output: '',
      isAmexMOS: false,
      messageFlash: '',
      messageAlertSuccessStatus: false,
      messageAlert: {
        unlocked: 'Welcome to American Express<sup>®</sup> reserved seating',
      },
    }
  },
  mounted() {
    this.renderContent()
    EventBus.$on('amex-unlocked--success', this.amexModeOfSale)
  },
  methods: {
    renderContent() {
      this.output = this.content.message

      if (window.ModeOfSaleId === 58) {
        this.amexModeOfSale()
      }
    },
    amexModeOfSale() {
      this.messageFlash = this.messageAlert.unlocked
      this.messageAlertSuccessStatus = true
      this.isAmexMOS = true
    },
    openModal() {
      EventBus.$emit('open-modal--amex')
    },
  }
}
</script>
